import { AUTH_ACTIONS } from "../../constants";

export function authenticateUser() {
    return {
        type: AUTH_ACTIONS.AUTHENTICATE
    };
}

export function authenticatedUser() {
    return {
        type: AUTH_ACTIONS.AUTHENTICATED
    };
}

export function failedAuthenticateUser() {
    return {
        type: AUTH_ACTIONS.FAILED_AUTHENTICATE
    };
}

export function logout() {
    return {
        type: AUTH_ACTIONS.LOGOUT
    };
}
